<script>
import * as m from '@app/paraglide/messages.js';
import {
    showModal
} from "@app/store/modalStore.svelte.js";
import {
    eventGroupState
} from "@app/store/eventGroupStore.svelte.js";
import {
    projectState
} from "@app/store/projectStore.svelte.js";
import {
    toast
} from '@zerodevx/svelte-toast';
import {
    insertHistoryAction
} from "@app/store/historyStore.svelte.js";
import {
    BarLoader
} from 'svelte-loading-spinners';
import {
    tagState,
    getSelectedTagSet,
    normalizeTagSetId,
    loadTagSets,
    saveSelectedTagSetId,
} from "@app/store/tagStore.svelte.js";

// Load tag sets on first mount; subsequent mounts reuse cached store data
let loadingPromise = $state(loadTagSets());
let selectedTagSet = $derived(getSelectedTagSet());

// Persist selectedId to localStorage whenever the user changes the dropdown
$effect(() => {
    if (tagState.loaded && tagState.selectedId !== null) {
        // Reading tagState.selectedId subscribes to changes from the <select> bind
        saveSelectedTagSetId(tagState.selectedId);
    }
});

function refresh() {
    loadingPromise = loadTagSets(tagState.selectedId, true);
}

function insertEventTag(tag) {
    if (eventGroupState[projectState.selected].selected.length > 0 && eventGroupState[projectState.selected]) {
        eventGroupState[projectState.selected].selected.forEach((eventId) => {
            if (eventGroupState[projectState.selected].events[eventId]) {
                eventGroupState[projectState.selected].events[eventId].tags = [
                    ...eventGroupState[projectState.selected].events[eventId].tags.filter((tg) => {
                        return tg.id !== tag.id;
                    }),
                    tag,
                ];
            }
        });

        toast.push(m.tags_event_updated_toast(), {classes: ['toast-success']});

        insertHistoryAction({
            name: "insert tag",
            eventGroup: projectState.selected,
            snapshots: [{
                store: "eventGroupState",
                value: JSON.stringify(eventGroupState),
            }],
        });
    }
}
</script>

<div>
    {#await loadingPromise}
    <div class="d-flex justify-content-center align-items-center p-3">
        <BarLoader size="200" color="#1eb4b2" unit="px" duration="3s"></BarLoader>
    </div>
    {:then}
    <div class="row g-1 mb-2">
        <div class="col-auto">
            <select 
                class="form-select form-select-sm" 
                bind:value={tagState.selectedId} 
                title={m.tags_selected_title()}>
                {#each tagState.sets as set (set.id)}
                    <option value={normalizeTagSetId(set.id)}>{set.name}</option>
                {/each}
            </select>
        </div>
        <div class="col">
            <button
                id="refreshTagsBtn"
                aria-label={m.tags_refresh_aria_label()}
                type="button"
                class="btn btn-sm btn-light"
                title={m.tags_refresh_title()}
                onclick={refresh}>
                <i class="bi bi-arrow-clockwise"></i>
            </button>
        </div>
        <div class="col">
            <button
                id="tagsManagerBtn"
                aria-label={m.tags_open_manager_aria_label()}
                type="button"
                class="btn btn-light btn-sm float-end"
                onclick={() => showModal("tagsManager")}>
                <i class="bi bi-three-dots-vertical"></i>
            </button>
        </div>
    </div>

    <div id="TagsWrapper" class="rounded">
        <div class="row mx-1 py-1">
            <div id="TagsList" class="col-11 p-2">
                {#if selectedTagSet && selectedTagSet.tags}
                {#each selectedTagSet.tags as tag (tag.id)}
                <button
                    id={"tagBtn-" + tag.id}
                    aria-label={m.tags_add_tag_aria_label({ tag: tag.term })}
                    type="button"
                    class={"btn btn-sm btn-" + tag.color + " m-1"}
                    onclick={() => insertEventTag(tag)}>
                    {tag.term}
                </button>
                {/each}
                {:else}
                <p class="m-3 text-muted">{m.tags_no_tags_found()}</p>
                {/if}
            </div>
        </div>
    </div>
    {/await}
</div>

<style lang="css">
#TagsWrapper {
    background-color: rgba(255, 255, 255, 0.03);
}
</style>
